import React, {memo, FC} from "react";

interface Props {
    height: number;
}

const VerticalSpaceComponent: FC<Props> = props => {
    return <div style={{height: props.height}}></div>;
}
VerticalSpaceComponent.displayName = 'VerticalSpaceComponent';

// Fix TypeScript error by explicitly typing the memo component
export const VerticalSpace: React.FC<Props> = memo(VerticalSpaceComponent);
VerticalSpace.displayName = 'VerticalSpace';